/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as SplatRouteImport } from './routes/$'
import { Route as ProtectedIndexRouteImport } from './routes/_protected.index'
import { Route as InvitationsTokenRouteImport } from './routes/invitations.$token'
import { Route as ProtectedTransformationsRouteImport } from './routes/_protected.transformations'
import { Route as ProtectedToastTestRouteImport } from './routes/_protected.toast-test'
import { Route as ProtectedSourcesRouteImport } from './routes/_protected.sources'
import { Route as ProtectedSchedulesRouteImport } from './routes/_protected.schedules'
import { Route as ProtectedIssuesRouteImport } from './routes/_protected.issues'
import { Route as ProtectedDeviceCodesRouteImport } from './routes/_protected.device-codes'
import { Route as ProtectedDestinationsRouteImport } from './routes/_protected.destinations'
import { Route as ProtectedConnectionsRouteImport } from './routes/_protected.connections'
import { Route as ProtectedConnectionBuilderRouteImport } from './routes/_protected.connection-builder'
import { Route as ProtectedCircuitBreakersRouteImport } from './routes/_protected.circuit-breakers'
import { Route as ProtectedBridgeBuilderRouteImport } from './routes/_protected.bridge-builder'
import { Route as ProtectedAccountRouteImport } from './routes/_protected.account'
import { Route as ProtectedTransformationsIndexRouteImport } from './routes/_protected.transformations.index'
import { Route as ProtectedSourcesIndexRouteImport } from './routes/_protected.sources.index'
import { Route as ProtectedSchedulesIndexRouteImport } from './routes/_protected.schedules.index'
import { Route as ProtectedDestinationsIndexRouteImport } from './routes/_protected.destinations.index'
import { Route as ShareRTokenRouteImport } from './routes/share.r.$token'
import { Route as ProtectedTransformationsNewRouteImport } from './routes/_protected.transformations.new'
import { Route as ProtectedSourcesIdRouteImport } from './routes/_protected.sources.$id'
import { Route as ProtectedSchedulesIdRouteImport } from './routes/_protected.schedules.$id'
import { Route as ProtectedOrganizationSettingsRouteImport } from './routes/_protected.organization.settings'
import { Route as ProtectedIssuesIdRouteImport } from './routes/_protected.issues.$id'
import { Route as ProtectedEventsOutgoingRouteImport } from './routes/_protected.events.outgoing'
import { Route as ProtectedEventsIncomingRouteImport } from './routes/_protected.events.incoming'
import { Route as ProtectedEndpointsIdRouteImport } from './routes/_protected.endpoints_.$id'
import { Route as ProtectedDestinationsIdRouteImport } from './routes/_protected.destinations.$id'
import { Route as ProtectedConnectionBuilderIdRouteImport } from './routes/_protected.connection-builder.$id'
import { Route as ProtectedOrganizationSettingsIndexRouteImport } from './routes/_protected.organization.settings.index'
import { Route as ProtectedTransformationsViewIdRouteImport } from './routes/_protected.transformations.view.$id'
import { Route as ProtectedOrganizationSettingsUsageRouteImport } from './routes/_protected.organization.settings.usage'
import { Route as ProtectedOrganizationSettingsSigningSecretRouteImport } from './routes/_protected.organization.settings.signing-secret'
import { Route as ProtectedOrganizationSettingsSecretsRouteImport } from './routes/_protected.organization.settings.secrets'
import { Route as ProtectedOrganizationSettingsNotificationsRouteImport } from './routes/_protected.organization.settings.notifications'
import { Route as ProtectedOrganizationSettingsMembersRouteImport } from './routes/_protected.organization.settings.members'
import { Route as ProtectedOrganizationSettingsBillingRouteImport } from './routes/_protected.organization.settings.billing'
import { Route as ProtectedOrganizationSettingsApiKeysRouteImport } from './routes/_protected.organization.settings.api-keys'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedIndexRoute = ProtectedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedRoute,
} as any)
const InvitationsTokenRoute = InvitationsTokenRouteImport.update({
  id: '/invitations/$token',
  path: '/invitations/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedTransformationsRoute =
  ProtectedTransformationsRouteImport.update({
    id: '/transformations',
    path: '/transformations',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedToastTestRoute = ProtectedToastTestRouteImport.update({
  id: '/toast-test',
  path: '/toast-test',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSourcesRoute = ProtectedSourcesRouteImport.update({
  id: '/sources',
  path: '/sources',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSchedulesRoute = ProtectedSchedulesRouteImport.update({
  id: '/schedules',
  path: '/schedules',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedIssuesRoute = ProtectedIssuesRouteImport.update({
  id: '/issues',
  path: '/issues',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDeviceCodesRoute = ProtectedDeviceCodesRouteImport.update({
  id: '/device-codes',
  path: '/device-codes',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDestinationsRoute = ProtectedDestinationsRouteImport.update({
  id: '/destinations',
  path: '/destinations',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedConnectionsRoute = ProtectedConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedConnectionBuilderRoute =
  ProtectedConnectionBuilderRouteImport.update({
    id: '/connection-builder',
    path: '/connection-builder',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedCircuitBreakersRoute =
  ProtectedCircuitBreakersRouteImport.update({
    id: '/circuit-breakers',
    path: '/circuit-breakers',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedBridgeBuilderRoute = ProtectedBridgeBuilderRouteImport.update({
  id: '/bridge-builder',
  path: '/bridge-builder',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedAccountRoute = ProtectedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedTransformationsIndexRoute =
  ProtectedTransformationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedTransformationsRoute,
  } as any)
const ProtectedSourcesIndexRoute = ProtectedSourcesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedSourcesRoute,
} as any)
const ProtectedSchedulesIndexRoute = ProtectedSchedulesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedSchedulesRoute,
} as any)
const ProtectedDestinationsIndexRoute =
  ProtectedDestinationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedDestinationsRoute,
  } as any)
const ShareRTokenRoute = ShareRTokenRouteImport.update({
  id: '/share/r/$token',
  path: '/share/r/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedTransformationsNewRoute =
  ProtectedTransformationsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedTransformationsRoute,
  } as any)
const ProtectedSourcesIdRoute = ProtectedSourcesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ProtectedSourcesRoute,
} as any)
const ProtectedSchedulesIdRoute = ProtectedSchedulesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ProtectedSchedulesRoute,
} as any)
const ProtectedOrganizationSettingsRoute =
  ProtectedOrganizationSettingsRouteImport.update({
    id: '/organization/settings',
    path: '/organization/settings',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedIssuesIdRoute = ProtectedIssuesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ProtectedIssuesRoute,
} as any)
const ProtectedEventsOutgoingRoute = ProtectedEventsOutgoingRouteImport.update({
  id: '/events/outgoing',
  path: '/events/outgoing',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedEventsIncomingRoute = ProtectedEventsIncomingRouteImport.update({
  id: '/events/incoming',
  path: '/events/incoming',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedEndpointsIdRoute = ProtectedEndpointsIdRouteImport.update({
  id: '/endpoints_/$id',
  path: '/endpoints/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDestinationsIdRoute = ProtectedDestinationsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ProtectedDestinationsRoute,
} as any)
const ProtectedConnectionBuilderIdRoute =
  ProtectedConnectionBuilderIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedConnectionBuilderRoute,
  } as any)
const ProtectedOrganizationSettingsIndexRoute =
  ProtectedOrganizationSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedOrganizationSettingsRoute,
  } as any)
const ProtectedTransformationsViewIdRoute =
  ProtectedTransformationsViewIdRouteImport.update({
    id: '/view/$id',
    path: '/view/$id',
    getParentRoute: () => ProtectedTransformationsRoute,
  } as any)
const ProtectedOrganizationSettingsUsageRoute =
  ProtectedOrganizationSettingsUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => ProtectedOrganizationSettingsRoute,
  } as any)
const ProtectedOrganizationSettingsSigningSecretRoute =
  ProtectedOrganizationSettingsSigningSecretRouteImport.update({
    id: '/signing-secret',
    path: '/signing-secret',
    getParentRoute: () => ProtectedOrganizationSettingsRoute,
  } as any)
const ProtectedOrganizationSettingsSecretsRoute =
  ProtectedOrganizationSettingsSecretsRouteImport.update({
    id: '/secrets',
    path: '/secrets',
    getParentRoute: () => ProtectedOrganizationSettingsRoute,
  } as any)
const ProtectedOrganizationSettingsNotificationsRoute =
  ProtectedOrganizationSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => ProtectedOrganizationSettingsRoute,
  } as any)
const ProtectedOrganizationSettingsMembersRoute =
  ProtectedOrganizationSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => ProtectedOrganizationSettingsRoute,
  } as any)
const ProtectedOrganizationSettingsBillingRoute =
  ProtectedOrganizationSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => ProtectedOrganizationSettingsRoute,
  } as any)
const ProtectedOrganizationSettingsApiKeysRoute =
  ProtectedOrganizationSettingsApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => ProtectedOrganizationSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/account': typeof ProtectedAccountRoute
  '/bridge-builder': typeof ProtectedBridgeBuilderRoute
  '/circuit-breakers': typeof ProtectedCircuitBreakersRoute
  '/connection-builder': typeof ProtectedConnectionBuilderRouteWithChildren
  '/connections': typeof ProtectedConnectionsRoute
  '/destinations': typeof ProtectedDestinationsRouteWithChildren
  '/device-codes': typeof ProtectedDeviceCodesRoute
  '/issues': typeof ProtectedIssuesRouteWithChildren
  '/schedules': typeof ProtectedSchedulesRouteWithChildren
  '/sources': typeof ProtectedSourcesRouteWithChildren
  '/toast-test': typeof ProtectedToastTestRoute
  '/transformations': typeof ProtectedTransformationsRouteWithChildren
  '/invitations/$token': typeof InvitationsTokenRoute
  '/': typeof ProtectedIndexRoute
  '/connection-builder/$id': typeof ProtectedConnectionBuilderIdRoute
  '/destinations/$id': typeof ProtectedDestinationsIdRoute
  '/endpoints/$id': typeof ProtectedEndpointsIdRoute
  '/events/incoming': typeof ProtectedEventsIncomingRoute
  '/events/outgoing': typeof ProtectedEventsOutgoingRoute
  '/issues/$id': typeof ProtectedIssuesIdRoute
  '/organization/settings': typeof ProtectedOrganizationSettingsRouteWithChildren
  '/schedules/$id': typeof ProtectedSchedulesIdRoute
  '/sources/$id': typeof ProtectedSourcesIdRoute
  '/transformations/new': typeof ProtectedTransformationsNewRoute
  '/share/r/$token': typeof ShareRTokenRoute
  '/destinations/': typeof ProtectedDestinationsIndexRoute
  '/schedules/': typeof ProtectedSchedulesIndexRoute
  '/sources/': typeof ProtectedSourcesIndexRoute
  '/transformations/': typeof ProtectedTransformationsIndexRoute
  '/organization/settings/api-keys': typeof ProtectedOrganizationSettingsApiKeysRoute
  '/organization/settings/billing': typeof ProtectedOrganizationSettingsBillingRoute
  '/organization/settings/members': typeof ProtectedOrganizationSettingsMembersRoute
  '/organization/settings/notifications': typeof ProtectedOrganizationSettingsNotificationsRoute
  '/organization/settings/secrets': typeof ProtectedOrganizationSettingsSecretsRoute
  '/organization/settings/signing-secret': typeof ProtectedOrganizationSettingsSigningSecretRoute
  '/organization/settings/usage': typeof ProtectedOrganizationSettingsUsageRoute
  '/transformations/view/$id': typeof ProtectedTransformationsViewIdRoute
  '/organization/settings/': typeof ProtectedOrganizationSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/account': typeof ProtectedAccountRoute
  '/bridge-builder': typeof ProtectedBridgeBuilderRoute
  '/circuit-breakers': typeof ProtectedCircuitBreakersRoute
  '/connection-builder': typeof ProtectedConnectionBuilderRouteWithChildren
  '/connections': typeof ProtectedConnectionsRoute
  '/device-codes': typeof ProtectedDeviceCodesRoute
  '/issues': typeof ProtectedIssuesRouteWithChildren
  '/toast-test': typeof ProtectedToastTestRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/': typeof ProtectedIndexRoute
  '/connection-builder/$id': typeof ProtectedConnectionBuilderIdRoute
  '/destinations/$id': typeof ProtectedDestinationsIdRoute
  '/endpoints/$id': typeof ProtectedEndpointsIdRoute
  '/events/incoming': typeof ProtectedEventsIncomingRoute
  '/events/outgoing': typeof ProtectedEventsOutgoingRoute
  '/issues/$id': typeof ProtectedIssuesIdRoute
  '/schedules/$id': typeof ProtectedSchedulesIdRoute
  '/sources/$id': typeof ProtectedSourcesIdRoute
  '/transformations/new': typeof ProtectedTransformationsNewRoute
  '/share/r/$token': typeof ShareRTokenRoute
  '/destinations': typeof ProtectedDestinationsIndexRoute
  '/schedules': typeof ProtectedSchedulesIndexRoute
  '/sources': typeof ProtectedSourcesIndexRoute
  '/transformations': typeof ProtectedTransformationsIndexRoute
  '/organization/settings/api-keys': typeof ProtectedOrganizationSettingsApiKeysRoute
  '/organization/settings/billing': typeof ProtectedOrganizationSettingsBillingRoute
  '/organization/settings/members': typeof ProtectedOrganizationSettingsMembersRoute
  '/organization/settings/notifications': typeof ProtectedOrganizationSettingsNotificationsRoute
  '/organization/settings/secrets': typeof ProtectedOrganizationSettingsSecretsRoute
  '/organization/settings/signing-secret': typeof ProtectedOrganizationSettingsSigningSecretRoute
  '/organization/settings/usage': typeof ProtectedOrganizationSettingsUsageRoute
  '/transformations/view/$id': typeof ProtectedTransformationsViewIdRoute
  '/organization/settings': typeof ProtectedOrganizationSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_protected/account': typeof ProtectedAccountRoute
  '/_protected/bridge-builder': typeof ProtectedBridgeBuilderRoute
  '/_protected/circuit-breakers': typeof ProtectedCircuitBreakersRoute
  '/_protected/connection-builder': typeof ProtectedConnectionBuilderRouteWithChildren
  '/_protected/connections': typeof ProtectedConnectionsRoute
  '/_protected/destinations': typeof ProtectedDestinationsRouteWithChildren
  '/_protected/device-codes': typeof ProtectedDeviceCodesRoute
  '/_protected/issues': typeof ProtectedIssuesRouteWithChildren
  '/_protected/schedules': typeof ProtectedSchedulesRouteWithChildren
  '/_protected/sources': typeof ProtectedSourcesRouteWithChildren
  '/_protected/toast-test': typeof ProtectedToastTestRoute
  '/_protected/transformations': typeof ProtectedTransformationsRouteWithChildren
  '/invitations/$token': typeof InvitationsTokenRoute
  '/_protected/': typeof ProtectedIndexRoute
  '/_protected/connection-builder/$id': typeof ProtectedConnectionBuilderIdRoute
  '/_protected/destinations/$id': typeof ProtectedDestinationsIdRoute
  '/_protected/endpoints_/$id': typeof ProtectedEndpointsIdRoute
  '/_protected/events/incoming': typeof ProtectedEventsIncomingRoute
  '/_protected/events/outgoing': typeof ProtectedEventsOutgoingRoute
  '/_protected/issues/$id': typeof ProtectedIssuesIdRoute
  '/_protected/organization/settings': typeof ProtectedOrganizationSettingsRouteWithChildren
  '/_protected/schedules/$id': typeof ProtectedSchedulesIdRoute
  '/_protected/sources/$id': typeof ProtectedSourcesIdRoute
  '/_protected/transformations/new': typeof ProtectedTransformationsNewRoute
  '/share/r/$token': typeof ShareRTokenRoute
  '/_protected/destinations/': typeof ProtectedDestinationsIndexRoute
  '/_protected/schedules/': typeof ProtectedSchedulesIndexRoute
  '/_protected/sources/': typeof ProtectedSourcesIndexRoute
  '/_protected/transformations/': typeof ProtectedTransformationsIndexRoute
  '/_protected/organization/settings/api-keys': typeof ProtectedOrganizationSettingsApiKeysRoute
  '/_protected/organization/settings/billing': typeof ProtectedOrganizationSettingsBillingRoute
  '/_protected/organization/settings/members': typeof ProtectedOrganizationSettingsMembersRoute
  '/_protected/organization/settings/notifications': typeof ProtectedOrganizationSettingsNotificationsRoute
  '/_protected/organization/settings/secrets': typeof ProtectedOrganizationSettingsSecretsRoute
  '/_protected/organization/settings/signing-secret': typeof ProtectedOrganizationSettingsSigningSecretRoute
  '/_protected/organization/settings/usage': typeof ProtectedOrganizationSettingsUsageRoute
  '/_protected/transformations/view/$id': typeof ProtectedTransformationsViewIdRoute
  '/_protected/organization/settings/': typeof ProtectedOrganizationSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/login'
    | '/reset-password'
    | '/account'
    | '/bridge-builder'
    | '/circuit-breakers'
    | '/connection-builder'
    | '/connections'
    | '/destinations'
    | '/device-codes'
    | '/issues'
    | '/schedules'
    | '/sources'
    | '/toast-test'
    | '/transformations'
    | '/invitations/$token'
    | '/'
    | '/connection-builder/$id'
    | '/destinations/$id'
    | '/endpoints/$id'
    | '/events/incoming'
    | '/events/outgoing'
    | '/issues/$id'
    | '/organization/settings'
    | '/schedules/$id'
    | '/sources/$id'
    | '/transformations/new'
    | '/share/r/$token'
    | '/destinations/'
    | '/schedules/'
    | '/sources/'
    | '/transformations/'
    | '/organization/settings/api-keys'
    | '/organization/settings/billing'
    | '/organization/settings/members'
    | '/organization/settings/notifications'
    | '/organization/settings/secrets'
    | '/organization/settings/signing-secret'
    | '/organization/settings/usage'
    | '/transformations/view/$id'
    | '/organization/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/login'
    | '/reset-password'
    | '/account'
    | '/bridge-builder'
    | '/circuit-breakers'
    | '/connection-builder'
    | '/connections'
    | '/device-codes'
    | '/issues'
    | '/toast-test'
    | '/invitations/$token'
    | '/'
    | '/connection-builder/$id'
    | '/destinations/$id'
    | '/endpoints/$id'
    | '/events/incoming'
    | '/events/outgoing'
    | '/issues/$id'
    | '/schedules/$id'
    | '/sources/$id'
    | '/transformations/new'
    | '/share/r/$token'
    | '/destinations'
    | '/schedules'
    | '/sources'
    | '/transformations'
    | '/organization/settings/api-keys'
    | '/organization/settings/billing'
    | '/organization/settings/members'
    | '/organization/settings/notifications'
    | '/organization/settings/secrets'
    | '/organization/settings/signing-secret'
    | '/organization/settings/usage'
    | '/transformations/view/$id'
    | '/organization/settings'
  id:
    | '__root__'
    | '/$'
    | '/_protected'
    | '/login'
    | '/reset-password'
    | '/_protected/account'
    | '/_protected/bridge-builder'
    | '/_protected/circuit-breakers'
    | '/_protected/connection-builder'
    | '/_protected/connections'
    | '/_protected/destinations'
    | '/_protected/device-codes'
    | '/_protected/issues'
    | '/_protected/schedules'
    | '/_protected/sources'
    | '/_protected/toast-test'
    | '/_protected/transformations'
    | '/invitations/$token'
    | '/_protected/'
    | '/_protected/connection-builder/$id'
    | '/_protected/destinations/$id'
    | '/_protected/endpoints_/$id'
    | '/_protected/events/incoming'
    | '/_protected/events/outgoing'
    | '/_protected/issues/$id'
    | '/_protected/organization/settings'
    | '/_protected/schedules/$id'
    | '/_protected/sources/$id'
    | '/_protected/transformations/new'
    | '/share/r/$token'
    | '/_protected/destinations/'
    | '/_protected/schedules/'
    | '/_protected/sources/'
    | '/_protected/transformations/'
    | '/_protected/organization/settings/api-keys'
    | '/_protected/organization/settings/billing'
    | '/_protected/organization/settings/members'
    | '/_protected/organization/settings/notifications'
    | '/_protected/organization/settings/secrets'
    | '/_protected/organization/settings/signing-secret'
    | '/_protected/organization/settings/usage'
    | '/_protected/transformations/view/$id'
    | '/_protected/organization/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  InvitationsTokenRoute: typeof InvitationsTokenRoute
  ShareRTokenRoute: typeof ShareRTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/': {
      id: '/_protected/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ProtectedIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/invitations/$token': {
      id: '/invitations/$token'
      path: '/invitations/$token'
      fullPath: '/invitations/$token'
      preLoaderRoute: typeof InvitationsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/transformations': {
      id: '/_protected/transformations'
      path: '/transformations'
      fullPath: '/transformations'
      preLoaderRoute: typeof ProtectedTransformationsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/toast-test': {
      id: '/_protected/toast-test'
      path: '/toast-test'
      fullPath: '/toast-test'
      preLoaderRoute: typeof ProtectedToastTestRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/sources': {
      id: '/_protected/sources'
      path: '/sources'
      fullPath: '/sources'
      preLoaderRoute: typeof ProtectedSourcesRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/schedules': {
      id: '/_protected/schedules'
      path: '/schedules'
      fullPath: '/schedules'
      preLoaderRoute: typeof ProtectedSchedulesRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/issues': {
      id: '/_protected/issues'
      path: '/issues'
      fullPath: '/issues'
      preLoaderRoute: typeof ProtectedIssuesRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/device-codes': {
      id: '/_protected/device-codes'
      path: '/device-codes'
      fullPath: '/device-codes'
      preLoaderRoute: typeof ProtectedDeviceCodesRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/destinations': {
      id: '/_protected/destinations'
      path: '/destinations'
      fullPath: '/destinations'
      preLoaderRoute: typeof ProtectedDestinationsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/connections': {
      id: '/_protected/connections'
      path: '/connections'
      fullPath: '/connections'
      preLoaderRoute: typeof ProtectedConnectionsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/connection-builder': {
      id: '/_protected/connection-builder'
      path: '/connection-builder'
      fullPath: '/connection-builder'
      preLoaderRoute: typeof ProtectedConnectionBuilderRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/circuit-breakers': {
      id: '/_protected/circuit-breakers'
      path: '/circuit-breakers'
      fullPath: '/circuit-breakers'
      preLoaderRoute: typeof ProtectedCircuitBreakersRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/bridge-builder': {
      id: '/_protected/bridge-builder'
      path: '/bridge-builder'
      fullPath: '/bridge-builder'
      preLoaderRoute: typeof ProtectedBridgeBuilderRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/account': {
      id: '/_protected/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof ProtectedAccountRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/transformations/': {
      id: '/_protected/transformations/'
      path: '/'
      fullPath: '/transformations/'
      preLoaderRoute: typeof ProtectedTransformationsIndexRouteImport
      parentRoute: typeof ProtectedTransformationsRoute
    }
    '/_protected/sources/': {
      id: '/_protected/sources/'
      path: '/'
      fullPath: '/sources/'
      preLoaderRoute: typeof ProtectedSourcesIndexRouteImport
      parentRoute: typeof ProtectedSourcesRoute
    }
    '/_protected/schedules/': {
      id: '/_protected/schedules/'
      path: '/'
      fullPath: '/schedules/'
      preLoaderRoute: typeof ProtectedSchedulesIndexRouteImport
      parentRoute: typeof ProtectedSchedulesRoute
    }
    '/_protected/destinations/': {
      id: '/_protected/destinations/'
      path: '/'
      fullPath: '/destinations/'
      preLoaderRoute: typeof ProtectedDestinationsIndexRouteImport
      parentRoute: typeof ProtectedDestinationsRoute
    }
    '/share/r/$token': {
      id: '/share/r/$token'
      path: '/share/r/$token'
      fullPath: '/share/r/$token'
      preLoaderRoute: typeof ShareRTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/transformations/new': {
      id: '/_protected/transformations/new'
      path: '/new'
      fullPath: '/transformations/new'
      preLoaderRoute: typeof ProtectedTransformationsNewRouteImport
      parentRoute: typeof ProtectedTransformationsRoute
    }
    '/_protected/sources/$id': {
      id: '/_protected/sources/$id'
      path: '/$id'
      fullPath: '/sources/$id'
      preLoaderRoute: typeof ProtectedSourcesIdRouteImport
      parentRoute: typeof ProtectedSourcesRoute
    }
    '/_protected/schedules/$id': {
      id: '/_protected/schedules/$id'
      path: '/$id'
      fullPath: '/schedules/$id'
      preLoaderRoute: typeof ProtectedSchedulesIdRouteImport
      parentRoute: typeof ProtectedSchedulesRoute
    }
    '/_protected/organization/settings': {
      id: '/_protected/organization/settings'
      path: '/organization/settings'
      fullPath: '/organization/settings'
      preLoaderRoute: typeof ProtectedOrganizationSettingsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/issues/$id': {
      id: '/_protected/issues/$id'
      path: '/$id'
      fullPath: '/issues/$id'
      preLoaderRoute: typeof ProtectedIssuesIdRouteImport
      parentRoute: typeof ProtectedIssuesRoute
    }
    '/_protected/events/outgoing': {
      id: '/_protected/events/outgoing'
      path: '/events/outgoing'
      fullPath: '/events/outgoing'
      preLoaderRoute: typeof ProtectedEventsOutgoingRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/events/incoming': {
      id: '/_protected/events/incoming'
      path: '/events/incoming'
      fullPath: '/events/incoming'
      preLoaderRoute: typeof ProtectedEventsIncomingRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/endpoints_/$id': {
      id: '/_protected/endpoints_/$id'
      path: '/endpoints/$id'
      fullPath: '/endpoints/$id'
      preLoaderRoute: typeof ProtectedEndpointsIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/destinations/$id': {
      id: '/_protected/destinations/$id'
      path: '/$id'
      fullPath: '/destinations/$id'
      preLoaderRoute: typeof ProtectedDestinationsIdRouteImport
      parentRoute: typeof ProtectedDestinationsRoute
    }
    '/_protected/connection-builder/$id': {
      id: '/_protected/connection-builder/$id'
      path: '/$id'
      fullPath: '/connection-builder/$id'
      preLoaderRoute: typeof ProtectedConnectionBuilderIdRouteImport
      parentRoute: typeof ProtectedConnectionBuilderRoute
    }
    '/_protected/organization/settings/': {
      id: '/_protected/organization/settings/'
      path: '/'
      fullPath: '/organization/settings/'
      preLoaderRoute: typeof ProtectedOrganizationSettingsIndexRouteImport
      parentRoute: typeof ProtectedOrganizationSettingsRoute
    }
    '/_protected/transformations/view/$id': {
      id: '/_protected/transformations/view/$id'
      path: '/view/$id'
      fullPath: '/transformations/view/$id'
      preLoaderRoute: typeof ProtectedTransformationsViewIdRouteImport
      parentRoute: typeof ProtectedTransformationsRoute
    }
    '/_protected/organization/settings/usage': {
      id: '/_protected/organization/settings/usage'
      path: '/usage'
      fullPath: '/organization/settings/usage'
      preLoaderRoute: typeof ProtectedOrganizationSettingsUsageRouteImport
      parentRoute: typeof ProtectedOrganizationSettingsRoute
    }
    '/_protected/organization/settings/signing-secret': {
      id: '/_protected/organization/settings/signing-secret'
      path: '/signing-secret'
      fullPath: '/organization/settings/signing-secret'
      preLoaderRoute: typeof ProtectedOrganizationSettingsSigningSecretRouteImport
      parentRoute: typeof ProtectedOrganizationSettingsRoute
    }
    '/_protected/organization/settings/secrets': {
      id: '/_protected/organization/settings/secrets'
      path: '/secrets'
      fullPath: '/organization/settings/secrets'
      preLoaderRoute: typeof ProtectedOrganizationSettingsSecretsRouteImport
      parentRoute: typeof ProtectedOrganizationSettingsRoute
    }
    '/_protected/organization/settings/notifications': {
      id: '/_protected/organization/settings/notifications'
      path: '/notifications'
      fullPath: '/organization/settings/notifications'
      preLoaderRoute: typeof ProtectedOrganizationSettingsNotificationsRouteImport
      parentRoute: typeof ProtectedOrganizationSettingsRoute
    }
    '/_protected/organization/settings/members': {
      id: '/_protected/organization/settings/members'
      path: '/members'
      fullPath: '/organization/settings/members'
      preLoaderRoute: typeof ProtectedOrganizationSettingsMembersRouteImport
      parentRoute: typeof ProtectedOrganizationSettingsRoute
    }
    '/_protected/organization/settings/billing': {
      id: '/_protected/organization/settings/billing'
      path: '/billing'
      fullPath: '/organization/settings/billing'
      preLoaderRoute: typeof ProtectedOrganizationSettingsBillingRouteImport
      parentRoute: typeof ProtectedOrganizationSettingsRoute
    }
    '/_protected/organization/settings/api-keys': {
      id: '/_protected/organization/settings/api-keys'
      path: '/api-keys'
      fullPath: '/organization/settings/api-keys'
      preLoaderRoute: typeof ProtectedOrganizationSettingsApiKeysRouteImport
      parentRoute: typeof ProtectedOrganizationSettingsRoute
    }
  }
}

interface ProtectedConnectionBuilderRouteChildren {
  ProtectedConnectionBuilderIdRoute: typeof ProtectedConnectionBuilderIdRoute
}

const ProtectedConnectionBuilderRouteChildren: ProtectedConnectionBuilderRouteChildren =
  {
    ProtectedConnectionBuilderIdRoute: ProtectedConnectionBuilderIdRoute,
  }

const ProtectedConnectionBuilderRouteWithChildren =
  ProtectedConnectionBuilderRoute._addFileChildren(
    ProtectedConnectionBuilderRouteChildren,
  )

interface ProtectedDestinationsRouteChildren {
  ProtectedDestinationsIdRoute: typeof ProtectedDestinationsIdRoute
  ProtectedDestinationsIndexRoute: typeof ProtectedDestinationsIndexRoute
}

const ProtectedDestinationsRouteChildren: ProtectedDestinationsRouteChildren = {
  ProtectedDestinationsIdRoute: ProtectedDestinationsIdRoute,
  ProtectedDestinationsIndexRoute: ProtectedDestinationsIndexRoute,
}

const ProtectedDestinationsRouteWithChildren =
  ProtectedDestinationsRoute._addFileChildren(
    ProtectedDestinationsRouteChildren,
  )

interface ProtectedIssuesRouteChildren {
  ProtectedIssuesIdRoute: typeof ProtectedIssuesIdRoute
}

const ProtectedIssuesRouteChildren: ProtectedIssuesRouteChildren = {
  ProtectedIssuesIdRoute: ProtectedIssuesIdRoute,
}

const ProtectedIssuesRouteWithChildren = ProtectedIssuesRoute._addFileChildren(
  ProtectedIssuesRouteChildren,
)

interface ProtectedSchedulesRouteChildren {
  ProtectedSchedulesIdRoute: typeof ProtectedSchedulesIdRoute
  ProtectedSchedulesIndexRoute: typeof ProtectedSchedulesIndexRoute
}

const ProtectedSchedulesRouteChildren: ProtectedSchedulesRouteChildren = {
  ProtectedSchedulesIdRoute: ProtectedSchedulesIdRoute,
  ProtectedSchedulesIndexRoute: ProtectedSchedulesIndexRoute,
}

const ProtectedSchedulesRouteWithChildren =
  ProtectedSchedulesRoute._addFileChildren(ProtectedSchedulesRouteChildren)

interface ProtectedSourcesRouteChildren {
  ProtectedSourcesIdRoute: typeof ProtectedSourcesIdRoute
  ProtectedSourcesIndexRoute: typeof ProtectedSourcesIndexRoute
}

const ProtectedSourcesRouteChildren: ProtectedSourcesRouteChildren = {
  ProtectedSourcesIdRoute: ProtectedSourcesIdRoute,
  ProtectedSourcesIndexRoute: ProtectedSourcesIndexRoute,
}

const ProtectedSourcesRouteWithChildren =
  ProtectedSourcesRoute._addFileChildren(ProtectedSourcesRouteChildren)

interface ProtectedTransformationsRouteChildren {
  ProtectedTransformationsNewRoute: typeof ProtectedTransformationsNewRoute
  ProtectedTransformationsIndexRoute: typeof ProtectedTransformationsIndexRoute
  ProtectedTransformationsViewIdRoute: typeof ProtectedTransformationsViewIdRoute
}

const ProtectedTransformationsRouteChildren: ProtectedTransformationsRouteChildren =
  {
    ProtectedTransformationsNewRoute: ProtectedTransformationsNewRoute,
    ProtectedTransformationsIndexRoute: ProtectedTransformationsIndexRoute,
    ProtectedTransformationsViewIdRoute: ProtectedTransformationsViewIdRoute,
  }

const ProtectedTransformationsRouteWithChildren =
  ProtectedTransformationsRoute._addFileChildren(
    ProtectedTransformationsRouteChildren,
  )

interface ProtectedOrganizationSettingsRouteChildren {
  ProtectedOrganizationSettingsApiKeysRoute: typeof ProtectedOrganizationSettingsApiKeysRoute
  ProtectedOrganizationSettingsBillingRoute: typeof ProtectedOrganizationSettingsBillingRoute
  ProtectedOrganizationSettingsMembersRoute: typeof ProtectedOrganizationSettingsMembersRoute
  ProtectedOrganizationSettingsNotificationsRoute: typeof ProtectedOrganizationSettingsNotificationsRoute
  ProtectedOrganizationSettingsSecretsRoute: typeof ProtectedOrganizationSettingsSecretsRoute
  ProtectedOrganizationSettingsSigningSecretRoute: typeof ProtectedOrganizationSettingsSigningSecretRoute
  ProtectedOrganizationSettingsUsageRoute: typeof ProtectedOrganizationSettingsUsageRoute
  ProtectedOrganizationSettingsIndexRoute: typeof ProtectedOrganizationSettingsIndexRoute
}

const ProtectedOrganizationSettingsRouteChildren: ProtectedOrganizationSettingsRouteChildren =
  {
    ProtectedOrganizationSettingsApiKeysRoute:
      ProtectedOrganizationSettingsApiKeysRoute,
    ProtectedOrganizationSettingsBillingRoute:
      ProtectedOrganizationSettingsBillingRoute,
    ProtectedOrganizationSettingsMembersRoute:
      ProtectedOrganizationSettingsMembersRoute,
    ProtectedOrganizationSettingsNotificationsRoute:
      ProtectedOrganizationSettingsNotificationsRoute,
    ProtectedOrganizationSettingsSecretsRoute:
      ProtectedOrganizationSettingsSecretsRoute,
    ProtectedOrganizationSettingsSigningSecretRoute:
      ProtectedOrganizationSettingsSigningSecretRoute,
    ProtectedOrganizationSettingsUsageRoute:
      ProtectedOrganizationSettingsUsageRoute,
    ProtectedOrganizationSettingsIndexRoute:
      ProtectedOrganizationSettingsIndexRoute,
  }

const ProtectedOrganizationSettingsRouteWithChildren =
  ProtectedOrganizationSettingsRoute._addFileChildren(
    ProtectedOrganizationSettingsRouteChildren,
  )

interface ProtectedRouteChildren {
  ProtectedAccountRoute: typeof ProtectedAccountRoute
  ProtectedBridgeBuilderRoute: typeof ProtectedBridgeBuilderRoute
  ProtectedCircuitBreakersRoute: typeof ProtectedCircuitBreakersRoute
  ProtectedConnectionBuilderRoute: typeof ProtectedConnectionBuilderRouteWithChildren
  ProtectedConnectionsRoute: typeof ProtectedConnectionsRoute
  ProtectedDestinationsRoute: typeof ProtectedDestinationsRouteWithChildren
  ProtectedDeviceCodesRoute: typeof ProtectedDeviceCodesRoute
  ProtectedIssuesRoute: typeof ProtectedIssuesRouteWithChildren
  ProtectedSchedulesRoute: typeof ProtectedSchedulesRouteWithChildren
  ProtectedSourcesRoute: typeof ProtectedSourcesRouteWithChildren
  ProtectedToastTestRoute: typeof ProtectedToastTestRoute
  ProtectedTransformationsRoute: typeof ProtectedTransformationsRouteWithChildren
  ProtectedIndexRoute: typeof ProtectedIndexRoute
  ProtectedEndpointsIdRoute: typeof ProtectedEndpointsIdRoute
  ProtectedEventsIncomingRoute: typeof ProtectedEventsIncomingRoute
  ProtectedEventsOutgoingRoute: typeof ProtectedEventsOutgoingRoute
  ProtectedOrganizationSettingsRoute: typeof ProtectedOrganizationSettingsRouteWithChildren
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedAccountRoute: ProtectedAccountRoute,
  ProtectedBridgeBuilderRoute: ProtectedBridgeBuilderRoute,
  ProtectedCircuitBreakersRoute: ProtectedCircuitBreakersRoute,
  ProtectedConnectionBuilderRoute: ProtectedConnectionBuilderRouteWithChildren,
  ProtectedConnectionsRoute: ProtectedConnectionsRoute,
  ProtectedDestinationsRoute: ProtectedDestinationsRouteWithChildren,
  ProtectedDeviceCodesRoute: ProtectedDeviceCodesRoute,
  ProtectedIssuesRoute: ProtectedIssuesRouteWithChildren,
  ProtectedSchedulesRoute: ProtectedSchedulesRouteWithChildren,
  ProtectedSourcesRoute: ProtectedSourcesRouteWithChildren,
  ProtectedToastTestRoute: ProtectedToastTestRoute,
  ProtectedTransformationsRoute: ProtectedTransformationsRouteWithChildren,
  ProtectedIndexRoute: ProtectedIndexRoute,
  ProtectedEndpointsIdRoute: ProtectedEndpointsIdRoute,
  ProtectedEventsIncomingRoute: ProtectedEventsIncomingRoute,
  ProtectedEventsOutgoingRoute: ProtectedEventsOutgoingRoute,
  ProtectedOrganizationSettingsRoute:
    ProtectedOrganizationSettingsRouteWithChildren,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  InvitationsTokenRoute: InvitationsTokenRoute,
  ShareRTokenRoute: ShareRTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
